import React from 'react';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import {
  TextAreaField,
  SubmitButton,
  CancelPopupButton,
} from 'ui/FormElement';
import { Formik, Form } from 'formik';

import actions from '../Actions';

export default function EditForm({ invoiceId, onHide }) {
  const onSubmit = (values, { setSubmitting }) => {
    actions.cancel(
      invoiceId,
      {
        reason: values.note,
      },
      () => {
        setSubmitting(false);
        onHide();
        document.location.reload();
      },
    );
  };

  return (

    <Formik
      enableReinitialize
      initialValues={{
        note: '',
      }}
      onSubmit={onSubmit}
    >
      {({ isSubmitting }) => (
        <Form className="needs-validation" noValidate="">

          <TextAreaField
            name="note"
            placeholder="Add a Note"
            row="10"
            label="Note"
            style={{ resize: 'vertical', height: '150px' }}
          />

          <div className="text-center mt50 mb30">
            <CancelPopupButton
              className="btn btn-primary btn-outline mr5 ml5 width-120"
              title="Cancel"
              onClick={onHide}
            />
            <SubmitButton
              title={isSubmitting ? 'Please, wait ...' : 'Confirm'}
              className="btn btn-primary submit-button mr5 ml5 width-120"
              disabled={isSubmitting}
            />
          </div>
        </Form>
      )}
    </Formik>
  );
}

EditForm.propTypes = {
  invoiceId: PropTypes.number.isRequired,
  onHide: PropTypes.func.isRequired,
};
